import React from 'react';
import { formatCount, formatCoverage } from '../../fields.utils';
import { Box, Heading, Row, Go, Ghost, ErrorNote, Link } from './FinalisePrompt.styles';

const AFTER_DOWNLOAD = 'afterDownload';

const Frozen = ({ stoneCount, coverage }) => (
  <>
    <b>{formatCount(stoneCount)}</b> stones
    {coverage ? ` and ${coverage} of imaged ground` : ''}
  </>
);

export const FinalisePrompt = ({
  variant,
  survey,
  precision,
  fieldName,
  isSubmitting,
  error,
  onConfirm,
  onDismiss
}) => {
  const coverage =
    survey.coverage_ratio == null
      ? null
      : formatCoverage(survey.coverage_ratio, precision);

  return (
    <Box data-testid='finalise-prompt'>
      {variant === AFTER_DOWNLOAD ? (
        <>
          <Heading>Finalise this survey and start a new one?</Heading>
          You have the file. Finalising freezes this survey —{' '}
          <Frozen stoneCount={survey.stone_count} coverage={coverage} /> — as a read-only
          record you can come back to, and the map starts clean for the next stretch of
          work. Anything that arrives afterwards lands in the new survey. Leave it open
          and it just keeps collecting.
        </>
      ) : (
        <>
          <Heading>Finalise this survey?</Heading>
          The <b>{formatCount(survey.stone_count)}</b> stones on this map
          {coverage ? ` and the ${coverage} of ground behind them` : ''} become a
          read-only record of {fieldName}, and a new survey opens with a clean map. Every
          pass that arrives from now on lands in it — including anything a unit is still
          holding from before today. Nothing is deleted, and a stone nobody picked comes
          back on its own the next time the field is imaged.
        </>
      )}
      {error && <ErrorNote role='alert'>{error}</ErrorNote>}
      <Row>
        <Go type='button' disabled={isSubmitting} onClick={onConfirm}>
          {variant === AFTER_DOWNLOAD
            ? 'Finalise survey'
            : 'Finalise and start a new survey'}
        </Go>
        <Ghost type='button' disabled={isSubmitting} onClick={onDismiss}>
          {variant === AFTER_DOWNLOAD ? 'Not yet' : 'Cancel'}
        </Ghost>
      </Row>
    </Box>
  );
};

export const FinaliseLink = ({ onClick }) => (
  <Link type='button' onClick={onClick} data-testid='finalise-link'>
    Finalise this survey and start a new one →
  </Link>
);
